import React, { Component } from 'react';
import "./style.css"

class Intro extends Component {
    render() {
        return (
            <div>
                <div className="intro-heading">
                    <h1>Full-Stack Web Developer & Digital Platform Lead</h1>
                    <img className="intro-img" src={require('./img/me-taj.png')} alt="Sarah Clark" />
                </div>
                <div className="gradient"></div>
                <div className="details">
                    <p>Hi, I’m Sarah Clark, a full-stack web developer and digital platform lead who enjoys turning complex problems into practical, user-friendly solutions.</p>
                    <p>I build web applications, integrations, and automated workflows that connect people, technology, and business processes. Whether I’m designing a personalized experience, connecting systems through APIs, or tracking down a particularly stubborn issue, I’m always looking for a thoughtful solution.</p>
                    <p>I’m naturally curious and enjoy expanding my technical toolkit. Alongside my broader full-stack work, I’ve used React to build production features and am continuing to grow my experience with React and TypeScript. I also use AI-assisted tools to accelerate development and explore ideas while relying on careful testing and independent judgment.</p>
                    <p>Before development, I worked in design, owned a business, and led teams. That combination of creative, business, and technical experience helps me understand the bigger picture behind what I build.</p>
                    <p>When I’m not building something, you’ll usually find me planning my next trip or hanging out with family, friends, and my pups, Max and Mia.</p>
                    <p>Make yourself at home and explore my projects. If you have a question or simply want to connect, feel free to use the links at the top of the page.</p>
                </div>
            </div>
        )
    }
}

export default Intro;
